import { render, staticRenderFns } from "./WizardComponent.vue?vue&type=template&id=16edff24&scoped=true"
import script from "./WizardComponent.vue?vue&type=script&lang=js"
export * from "./WizardComponent.vue?vue&type=script&lang=js"
import style0 from "./WizardComponent.vue?vue&type=style&index=0&id=16edff24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16edff24",
  null
  
)

export default component.exports